<template>
  <component :is="tag" class="title">{{ text }}</component>
</template>

<script>
export default {
  name: 'BaseTitle',
  props: {
    text: {
      required: true,
      type: String,
      default: ''
    },
    tag: {
      type: String,
      default: "h2"
    },
  }
}
</script>

<style lang="scss">
.title {
  font-family: $ToyotaBook;
  font-size: 40px;
  font-weight: bold;
  font-style: normal;
  font-stretch: normal;
  line-height: 1.33;
  text-transform: uppercase;
  letter-spacing: normal;
  color: #282830;
  text-align: left;
}

@include media-min($tablet-width) {
  .title {
    font-size: 36px;
    line-height: 1;
  }
}

@include media-min($desktop-width) {
  .title {
    font-size: 44px;
    line-height: 48px;
  }
}
</style>



// WEBPACK FOOTER //
// components/_UI/BaseTitle.vue